import React from 'react';
import { useTranslation } from 'react-i18next';
import { StatusBadge, type StatusTone } from 'components/ui/status-badge';

const STATUS_TONE: Record<string, StatusTone> = {
  draft: 'neutral',
  active: 'success',
  published: 'success',
  finished: 'done',
  archived: 'neutral',
};

/** The test's status as a dotted badge; an unknown status shows its raw value. */
export function TestStatusBadge({ status, className }: { status: string; className?: string }) {
  const { t } = useTranslation();
  const known = status in STATUS_TONE;
  return (
    <StatusBadge tone={STATUS_TONE[status] ?? 'neutral'} className={className}>
      {known ? t(status) : status}
    </StatusBadge>
  );
}

export default TestStatusBadge;
